/**
 * Nav Active Link
 *
 */

custom.navActiveLink = (() => {
  let relativePath = window.location.pathname;

  relativePath = relativePath
    .replace('-new-arrivals', '')
    .replace('-one-of-a-kinds', '');

  const utilityLink = 'navigation__utility-link';
  const utilityLinkActiveClass = 'navigation__utility-link--active';

  const mainNavLink = 'navigation__primary-link';
  const mainNavActiveClass = 'navigation__primary-link--active';

  function addActiveClassToLink(name = null, activeClass) {
    if ($(name).hasClass(activeClass)) return;

    const href = $(name).attr('href');

    if (href === relativePath) {
      $(name).addClass(activeClass);
    }
    if ($(name).data('target-links')) {
      let childHref = $(name).data('target-links').split(',');
      childHref = childHref.map((link) => {
        const cleanLink =
          link.length && link !== '/' ? link.split('?')[0] : '/unused';
        return cleanLink;
      });
      if (childHref.includes(relativePath)) {
        $(name).addClass(activeClass);
      }
    }
    if ($(name).data('action') === 'Inspiration') {
      if (
        relativePath.includes('/blogs') ||
        relativePath.includes('/pages/gallery') ||
        relativePath.includes('/pages/catalog')
      ) {
        $(name).addClass(activeClass);
      }
    }
  }

  function init() {
    $(`.${mainNavLink}`).each((index, name) =>
      addActiveClassToLink(name, mainNavActiveClass),
    );
    if (!$(`.${utilityLink}`).length) return;
    $(`.${utilityLink}`).each((index, name) =>
      addActiveClassToLink(name, utilityLinkActiveClass),
    );
  }

  return {
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/nav-active-link.js